module.exports = __webpack_public_path__ + "static/img/85028D_2_R_20200306_LC.dfe0505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85028D_2_R_20200306_LC.png
// module id = SWrF
// module chunks = 0